<!--
 * @Description: 学生请假记录 详情
 * @Author: PF
 * @Date: 2023-11-30 16:56:02.154
 * @LastEditors: PF
 * @LastEditTime: 2025-03-17 14:18:24
-->
<template>
  <div>
    <el-dialog class="w800 h600" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon"><Document /></el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon><Close /></el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border class="descript-box">
        <el-descriptions-item label="学生" label-align="right" align="left" width="120px" span="2">{{ruleForm.xm}}</el-descriptions-item>
        <el-descriptions-item label="请假类型" label-align="right" align="left" width="120px" span="2">{{ruleForm.qjlxmc}}</el-descriptions-item>
        <el-descriptions-item label="请假开始时间" label-align="right" align="left" span="2">{{ruleForm.qjkssj}} - {{ruleForm.qjjssj}}</el-descriptions-item>
        <el-descriptions-item label="请假天数" label-align="right" align="left" span="2">{{ruleForm.qjts}}</el-descriptions-item>
        <el-descriptions-item label="是否离校" label-align="right" align="left" span="2"><span v-if="ruleForm.sflx===true">是</span><span v-if="ruleForm.sflx===false">否</span></el-descriptions-item>
        <el-descriptions-item label="状态" label-align="right" align="left" span="2"><span v-if="ruleForm.zt">{{ruleForm.zt.name}}</span></el-descriptions-item>
        <el-descriptions-item label="申请时间" label-align="right" align="left" span="2">{{ruleForm.sqsj}}</el-descriptions-item>
        <el-descriptions-item label="申请方式" label-align="right" align="left" span="2"><span v-if="ruleForm.sqfs">{{ruleForm.sqfs.name}}</span></el-descriptions-item>
        <!-- <el-descriptions-item label="生效时间" label-align="right" align="left" span="2">{{ruleForm.sxsj}}</el-descriptions-item> -->
        <!-- <el-descriptions-item label="生效操作人" label-align="right" align="left" span="2">{{ruleForm.sxczrxm}}</el-descriptions-item> -->
        <el-descriptions-item label="实际请假天数" label-align="right" align="left" span="2">{{ruleForm.sjqjts}}</el-descriptions-item>
        <el-descriptions-item label="销假时间" label-align="right" align="left" span="2">{{ruleForm.xjsj}}</el-descriptions-item>
        <el-descriptions-item label="销假操作人" label-align="right" align="left" span="2">{{ruleForm.xjczrxm}}</el-descriptions-item>
        <el-descriptions-item label="审批通过时间" label-align="right" align="left" span="2">{{ruleForm.sptgsj}}</el-descriptions-item>
        <el-descriptions-item label="请假原因" label-align="right" align="left" span="4">{{ruleForm.qjyy}}</el-descriptions-item>
        <el-descriptions-item label="拒绝原因" label-align="right" align="left" span="4" v-if="ruleForm.jjyy">{{ruleForm.jjyy}}</el-descriptions-item>
        <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({ url: '/api/v2/jiaowu/xueshengqingjiajilu/' + props.row.id, ruleForm })
    }
  }, { deep: true, immediate: true })
</script>
